export const roundToTwoDecimals = (value) => {
  return Math.round(value * 100) / 100
}

export function getColumnValue(coopGroup, columnId) {
  const columnValue = coopGroup.columnValues?.find((cv) => cv.coopGroupColumnId === columnId)
  return columnValue?.value ?? 0
}

export function calculateTotal(coopGroup, columns) {
  if (!columns || columns.length === 0) {
    return coopGroup.columnValues?.reduce((sum, cv) => sum + (cv.value || 0), 0) || 0
  }
  return columns.reduce((sum, col) => sum + getColumnValue(coopGroup, col.id), 0)
}

export const calculateColumnTotal = (coopGroups, columnId) => {
  const total = coopGroups.reduce((sum, group) => {
    const value = getColumnValue(group, columnId)
    return sum + (value || 0)
  }, 0)
  return roundToTwoDecimals(total)
}

export const calculateGlobalTotal = (coopGroups, columns) => {
  const total = columns.reduce((sum, col) => sum + calculateColumnTotal(coopGroups, col.id), 0)
  return roundToTwoDecimals(total)
}
